var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmphorEth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#paint0_linear_649_1467)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99866 1.66666L9.8894 2.04647V13.0668L9.99866 13.1784L14.997 10.1546L9.99866 1.66666Z",
    fill: "#E3E3E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99849 1.66666L5 10.1546L9.99849 13.1784V7.8294V1.66666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99859 14.1469L9.93701 14.2237V18.1493L9.99859 18.3333L15 11.1247L9.99859 14.1469Z",
    fill: "#E3E3E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99849 18.3333V14.1469L5 11.1247L9.99849 18.3333Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99829 13.1783L14.9967 10.1546L9.99829 7.82938V13.1783Z",
    fill: "#C7C7C7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.1546L9.99849 13.1783V7.82938L5 10.1546Z",
    fill: "#E7E7E7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_649_1467",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F50D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7002B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmphorEth);
export default __webpack_public_path__ + "static/media/amphor_eth.f41a2d83d1110af15c184e55b1c2a492.svg";
export { ForwardRef as ReactComponent };